export const URL = window.URL;
export const URLSearchParams = window.URLSearchParams;
export default window.URL;